export default "__VITE_ASSET__BMd1k9C9__"